
// TASK SHOW
export const DEFAULT_LIMIT = 10;

// Storage
export const USER_INFO_TEXT = 'userInfo';

// Status
export const SUCCESS_MESSAGE = 'Request successful';
export const ERROR_MESSAGE = 'Something went wrong';

// Toast
export const DEFAULT_TOAST_DURATION = 2000;

// Status
export const ERROR_TEXT = 'error';
export const SUCCESS_TEXT = 'success';
export const INFO_TEXT = 'info';